"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "moglia": {
    "9337b291": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "skipSearch": false
    }],
    "gerra-ghetto": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bbdb682f": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "skipSearch": false
    }],
    "ghetto-rocchetta": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a3b80806": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "skipSearch": false
    }],
    "ghisione": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "moglia"
    }],
    "e0ca5c7f": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "skipSearch": false
    }],
    "rocchetta": [{
      "hkey": "04fe4135",
      "slug": "ghetto-ghisione-rocchetta",
      "name": "Ghetto-Ghisione-Rocchetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "moglia"
    }]
  }
};
exports["default"] = _default;